'use strict';

var bluebird = require('bluebird');
var _ = require('lodash');
function HolidaysAndSpecialsEventsDataRetrieverService(Restangular, currentStateCriteriaService, momentService, momentConstants, hseConstants, configurationService) {
  var type = 'DA_SeasonalityEvent';
  var dataProviderService = Restangular.service('configuration').one('hep').all('daSeasonalityEvents');
  var updateBulkHepService = Restangular.service('configuration').one('hep').one('bulk');
  var deleteHepService = Restangular.service('configuration').one('hep').one('key');
  function removeEvents(events) {
    return Promise.all(_.map(events, function (event) {
      var payload = {
        hepKey: event.key,
        type: type
      };
      return deleteHepService.remove(payload);
    }));
  }
  function transformSearchCriteriaRules(rules) {
    var rule = _.find(rules, {
      category: 'Location',
      criterion: 'Market',
      field: 'custom:market'
    });
    if (rule) {
      return _.get(rule, 'leftOperand', []);
    }
    rule = _.find(rules, {
      category: 'Location',
      criterion: 'Market Origin',
      field: 'origin'
    });
    if (rule) {
      return transformSingleEntityToMarket(rule);
    }
    rule = _.find(rules, {
      category: 'Location',
      criterion: 'Market Destination',
      field: 'destination'
    });
    if (rule) {
      return transformSingleEntityToMarket(rule, true);
    }
    return [];
  }
  function transformSingleEntityToMarket(rule, isDestination) {
    var markets = configurationService.getMarkets();
    return _.chain(rule).get('leftOperand', []).thru(function (entities) {
      return _.chain(markets).filter(function (m) {
        if (isDestination) {
          return _.includes(entities, m.destination);
        }
        return _.includes(entities, m.origin);
      }).map(function (m) {
        return [m.origin, m.destination].join('-');
      }).value();
    }).value();
  }
  function getEvents() {
    var searchCriteria = _.cloneDeep(currentStateCriteriaService.getSearchCriteria());
    var markets = transformSearchCriteriaRules(searchCriteria.rules || []);
    if (_.isEmpty(markets)) {
      return bluebird.resolve([]);
    }
    return bluebird.all(_.chain(markets).chunk(hseConstants.MARKETS_PER_REQUEST).map(getEventsFromAPI).value()).then(mergeMarkets).then(filterDuplicates);
  }
  function filterDuplicates(markets) {
    return _.uniqBy(markets, function (market) {
      return [market.origin, market.destination, market.eventId].join(':');
    });
  }
  function getEventsFromAPI(markets) {
    return dataProviderService.get('', {
      markets: markets.join(',')
    }).then(transform);
  }
  function mergeMarkets(apiResponses) {
    return _.flatten(apiResponses);
  }
  function airportTransform(airport) {
    if (airport === 'All') {
      return 'ALLS';
    }
    return airport;
  }
  function airportInvert(airport) {
    if (airport === 'ALLS') {
      return 'All';
    }
    return airport;
  }
  function buildPayload(row, eventId) {
    var payload = {
      type: type,
      attributes: {
        origin: airportTransform(row.origin),
        destination: airportTransform(row.destination)
      },
      properties: {
        eventName: row.eventName,
        eventType: row.eventType,
        startDate: row.startDate.format(momentConstants.FORMATS.DATE_ISO),
        endDate: row.endDate.format(momentConstants.FORMATS.DATE_ISO)
      }
    };
    if (row.eventId) {
      payload.attributes.eventId = row.eventId;
    }
    if (row.isNewlyAdded) {
      payload.attributes.eventId = eventId;
    }
    return payload;
  }
  function transform(hepResult) {
    var hepList = _.get(hepResult, 'hepList', []);
    return _.transform(hepList, function (hepAccumulator, hep) {
      var entry = {};
      entry.origin = airportInvert(_.get(hep, 'attributes.origin'));
      entry.destination = airportInvert(_.get(hep, 'attributes.destination'));
      entry.eventId = _.get(hep, 'attributes.eventId');
      entry.eventName = _.get(hep, 'properties.eventName');
      entry.eventType = _.get(hep, 'properties.eventType');
      entry.startDate = _.get(hep, 'properties.startDate');
      entry.endDate = _.get(hep, 'properties.endDate');
      entry.lastUpdatedAt = _.get(hep, 'lastUpdatedAt');
      entry.lastUpdatedBy = _.get(hep, 'lastUpdatedBy');
      entry.key = _.get(hep, 'hepKey');
      entry.startDate = momentService.of(entry.startDate, momentService.FIELD.CREATED_DATE);
      entry.endDate = momentService.of(entry.endDate, momentService.FIELD.CREATED_DATE);
      entry.lastUpdatedAt = momentService.of(entry.lastUpdatedAt, momentService.FIELD.LAST_UPDATED_AT);
      hepAccumulator.push(entry);
    }, []);
  }
  function saveEvents(tranformedEvents) {
    var payload = {
      value: tranformedEvents
    };
    return updateBulkHepService.customPUT(payload, undefined, {
      upsert: true
    });
  }
  return {
    getEvents: getEvents,
    buildPayload: buildPayload,
    saveEvents: saveEvents,
    removeEvents: removeEvents
  };
}
HolidaysAndSpecialsEventsDataRetrieverService.$inject = ['Restangular', 'CurrentStateCriteriaService', 'MomentService', 'MomentConstants', 'HolidaysAndSpecialsEventsConstants', 'ConfigurationService'];
module.exports = HolidaysAndSpecialsEventsDataRetrieverService;